import React, { useEffect, useState } from 'react';
import { me } from '../api';
import { useGlobalContext } from '../stores/global';

export default function Authentication(props: any) {
  const token = props.match?.params?.token;
  const { dispatch } = useGlobalContext();
  const [message, setMessage] = useState('Iniciando sesión...');

  useEffect(() => {
    me(token)
      .then((response) => {
        dispatch({
          type: 'SET_USER',
          payload: { ...response.data.data, token },
        });
      })
      .then(() => {
        window.location.href = '/';
      })
      .catch((e) => {
        setMessage(
          'Ocurrió un error iniciando sesión en tu cuenta...' + e?.message
        );
      });
  }, []);

  return <div>{message}</div>;
}
